<!-- Should be used in conjunction with `error.js` mixin -->
<template>
  <div class="error" :class="{ visible: hasError }" :style="styleVars">
    <ul v-if="errors.length > 1">
      <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
    </ul>
    <div class="text-truncate" v-else>{{ errors[0] }}</div>
  </div>
</template>
<script lang="ts">
export default {
  props: {
    errors: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  computed: {
    hasError() {
      return this.errors?.length > 0
    },
    styleVars() {
      return {
        '--height-expanded': this.errors?.length * 24 + 'px',
      }
    },
  },
}
</script>
<style lang="sass" scoped>
.error
  height: 2px
  opacity: 0
  transition: height .1s ease, opacity .1s ease

.visible
  height: var(--height-expanded)
  opacity: 1
</style>
